export function customerHubContractId(value) {
  return value === null || value === undefined ? "" : String(value).trim().toLowerCase()
}

// The existing upgrade endpoint defines which packages can be booked for its contract.
// Keep its distinctions (including quantity packages and other studios) intact.
export function customerHubUpgradeOptions(possibilities, isAdult = false) {
  if (!customerHubContractId(possibilities?.contractID)) return []
  return [false, true].flatMap(externalPackage => {
    const packages = externalPackage ? possibilities.externalPackages : possibilities.availablePackages
    return (Array.isArray(packages) ? packages : [])
      .filter(pack => typeof pack?.packageName === "string" && pack.packageName.trim() && (isAdult || !pack.hideForMinors))
      .map((pack, index) => ({ ...pack, externalPackage, key: `${externalPackage ? 'external' : 'own'}-${index}-${pack.packageName}` }))
  })
}

export function customerHubInitialUpgrade(possibilities, selection, isAdult = false) {
  if (!selection || !customerHubContractId(selection.contractID) || customerHubContractId(selection.contractID) !== customerHubContractId(possibilities?.contractID)) return null
  const packages = selection.externalPackage ? possibilities.externalPackages : possibilities.availablePackages
  return (Array.isArray(packages) ? packages : []).find(pack => pack.packageName === selection.packageName && (isAdult || !pack.hideForMinors)) || null
}

export function customerHubPackageIcon(value) {
  const name = String(value || "").toLocaleLowerCase("de-CH")
  if (/getränk|drink|wasser/.test(name)) return "mdi-cup-water"
  if (/mescan|messung|analyse/.test(name)) return "mdi-scale-bathroom"
  if (/pelvi|becken/.test(name)) return "mdi-seat-outline"
  if (/milon|zirkel/.test(name)) return "mdi-dumbbell"
  if (/sauna|wellness|spa/.test(name)) return "mdi-spa-outline"
  if (/solarium|sonne/.test(name)) return "mdi-white-balance-sunny"
  if (/hydro|massage/.test(name)) return "mdi-water-outline"
  if (/kinder|hort/.test(name)) return "mdi-teddy-bear"
  if (/tuch|handtuch/.test(name)) return "mdi-tshirt-crew-outline"
  return "mdi-check-circle-outline"
}
